import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { env } from "../utils/env";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";
import { displayError } from "../utils/error-handling";

export interface ProfileDocument {
  created_on: string;
  name: string;
  media: string;
  description: string;
  type: string;
}

const fetchProfileDocuments = async (
  authHeader: string,
  profileId: string | number,
) => {
  return axios.get<ProfileDocument[]>(
    `${env.verifyServiceUrl}individual/profile_document/?profile=${profileId}`,
    {
      headers: { Authorization: authHeader },
      skipGlobalErrorHandler: true,
    },
  );
};

export const useProfileDocuments = (profileId?: string | number) => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();

  return useQuery({
    queryKey: ["profileDocuments", profileId],
    queryFn: () =>
      fetchProfileDocuments(authHeader, profileId as string | number),
    enabled: !!profileId,
    retry: false,
    select: (response) => response.data,
    onError: (err: any) => {
      const status = err?.response?.status ?? err?.request?.status;

      const message =
        err?.response?.data?.detail || "Failed to load profile documents.";

      if (status === 500 || status === 503) {
        displayError(message);
      }

      if (status === 401) {
        navigate(ROUTE.LOGOUT);
      }
    },
  });
};
